import React, { Component } from 'react';

const Footer = (props) => (
    <footer>
        <p className="wrapper">&copy; 2019 Design and code by <a href="https://samdev.codes/">Sam Pilehvarian</a></p>
    </footer>
);

export default Footer;